import { FC } from "react";
import styled from "@emotion/styled";
import { SessionContextMention, MDSSessionConfig } from "@/mds/components/sessions/session.types";
import { MDSSessionContextItem } from "@/mds/components/sessions/session-parts/session-context-item";

interface Props {
  mentions: SessionContextMention[];
  config: MDSSessionConfig;
}

export const MDSSessionContextContainer: FC<Props> = ({ mentions, config }) => {
  if (!mentions?.length) return null;

  return (
    <StyledContextContainer>
      {mentions.map(mention => {
        const key =
          mention.kind === "NOTE"
            ? `note-${(mention as { note_id: string }).note_id}`
            : `collection-${(mention as { collection_id: string }).collection_id}`;

        return <MDSSessionContextItem key={key} mention={mention} config={config} />;
      })}
    </StyledContextContainer>
  );
};

const StyledContextContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing["2"]};
  margin-left: -6px;
`;
